import { EnumLanguage } from '@libs/constants';


/**------------------------------------------------------
 * Page Data
 */
export const LEGAL_COOKIE_BANNER_DATA: Partial<Record<EnumLanguage, ILegalCookieBannerData>> = {
	[EnumLanguage.EN]: {
		title 	 : `Hello! We're the Cookies!`,
		info  	 : `<p class="info-text text-justify pe-md-2 scroll-bar">
						We use cookies and similar technologies to keep our website running smoothly and analyze our
						traffic. With your permission, we'll also utilize these to gain valuable insights that help us
						continually improve our platform for your benefit. These technologies aid us in understanding
						how you interact with our content and site features. We value your privacy highly; the data we
						collect is anonymized, ensuring your personal details always remain confidential. Be assured,
						your data is secure with us; we never sell it to third parties. By accepting this message,
						you're agreeing to our
						<button
							class="btn btn-link p-0 dynamic-link-btn"
							routerLink="/legal/cookies-usage"
							(click)="saveChanges()"
						>
							Cookies Usage
						</button>
						(which you can adjust later according to your preferences in the settings) and our
						<button
							class="btn btn-link p-0 dynamic-link-btn"
							routerLink="/legal/privacy-policy"
							(click)="saveChanges()"
						>
							Privacy Policy
						</button>`,
		accept 	 : `Accept All`,
		settings : {
			title: 'Cookie Settings',
			back : `Go Back`,
			save : `Save`,
			accept: `Accept All`
		},
		consent  : `Continue without Consent`
	},
	[EnumLanguage.DE]: {
		title 	 : `Hallo! Wir sind die Kekse!`,
		info  	 : `<p class="info-text text-justify pe-md-2 scroll-bar">
						Wir verwenden Cookies und ähnliche Technologien, um den reibungslosen Betrieb unserer Website zu gewährleisten und unsere Website zu analysieren
						Verkehr. Mit Ihrer Erlaubnis nutzen wir diese auch, um wertvolle Erkenntnisse zu gewinnen, die uns weiterhelfen
						Wir verbessern unsere Plattform kontinuierlich zu Ihrem Vorteil. Diese Technologien helfen uns beim Verständnis
						wie Sie mit unseren Inhalten und Website-Funktionen interagieren. Wir legen großen Wert auf Ihre Privatsphäre. die Daten, die wir
						Die Erfassung erfolgt anonymisiert, sodass Ihre persönlichen Daten stets vertraulich bleiben. Seien Sie versichert,
						Ihre Daten sind bei uns sicher; Wir verkaufen es niemals an Dritte. Indem Sie diese Nachricht akzeptieren,
						Sie stimmen unserem zu
						<button
							class="btn btn-link p-0 dynamic-link-btn"
							routerLink="/legal/cookies-usage"
							(click)="saveChanges()"
						>
							Verwendung von Cookies
						</button>
						(die Sie später in den Einstellungen entsprechend Ihren Vorlieben anpassen können) und unsere
						<button
							class="btn btn-link p-0 dynamic-link-btn"
							routerLink="/legal/privacy-policy"
							(click)="saveChanges()"
						>
							Datenschutzrichtlinie
						</button>`,
		accept 	 : `Alle akzeptieren`,
		settings : {
			title: 'Cookie-Einstellungen',
			back : `Geh zurück`,
			save : `Speichern`,
			accept: `Alle akzeptieren`
		},
		consent  : `Ohne Zustimmung fortfahren`
	}
};

export interface ILegalCookieBannerData {
	title 	 : string;
	info  	 : string;
	accept 	 : string;
	settings : {
		title: string;
		back : string;
		save : string;
		accept: string;
	};
	consent  : string;
}
